'use client'

import React, {useEffect, useRef, useState} from 'react'
import {LoadingSpinner} from "../loading/Spinner";

interface VideoPlayerProps {
  url: string
  onClose: () => void
}

export const VideoPlayer: React.FC<VideoPlayerProps> = ({
                                                          url,
                                                          onClose
                                                        }) => {
  const [loading, setLoading] = useState(true)
  const videoRef = useRef<HTMLVideoElement>(null)

  const isYouTube = url.includes('youtube.com') || url.includes('youtu.be')
  const isVimeo = url.includes('vimeo.com')
  const isDirectVideo = /\.(mp4|webm|ogg)$/.test(url)

  const getEmbedUrl = () => {
    if (isYouTube) {
      const videoId = url.split('v=')[1]?.split('&')[0] || url.split('/').pop()
      return `https://www.youtube.com/embed/${videoId}?autoplay=1&controls=1`
    }
    if (isVimeo) {
      const videoId = url.split('/').pop()
      return `https://player.vimeo.com/video/${videoId}?autoplay=1`
    }
    return url
  }

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  useEffect(() => {
    if (videoRef.current) {
      const onLoaded = () => setLoading(false)
      videoRef.current.addEventListener('loadeddata', onLoaded)
      return () => videoRef.current?.removeEventListener('loadeddata', onLoaded)
    }
  }, [videoRef.current])

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 px-2"
      onWheel={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onTouchMove={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <div
        className="relative w-full max-w-5xl aspect-video rounded-md overflow-hidden shadow-[1px_1px_2px_1px_rgba(80,92,98,1)]!">
        {loading && (
          <div
            className="fixed inset-0 z-9999 bg-bluegray-darker/85">
            <LoadingSpinner/>
          </div>
        )}

        {isYouTube || isVimeo ? (
          <iframe
            src={getEmbedUrl()}
            className="w-full h-full"
            allow="autoplay; fullscreen; encrypted-media"
            allowFullScreen
            onLoad={() => setLoading(false)}
          />
        ) : isDirectVideo ? (
          <video
            ref={videoRef}
            className="w-full h-full"
            controls
            autoPlay
            playsInline
            controlsList="nodownload"
          >
            <source
              src={url}/>
            Your
            browser
            does
            not
            support
            the
            video
            tag.
          </video>
        ) : (
          <p
            className="text-white text-center">Unsupported
            video
            format</p>
        )}

        <button
          onClick={onClose}
          className="absolute top-3 right-3 z-20"
          aria-label="Close video"
        >
          <i
            className="fa-duotone fa-light fa-square-xmark text-xl hover:text-light-red cursor-pointer"></i>
        </button>
      </div>
    </div>
  )
}
